import { createSelector } from "reselect";

export const Types = {
  GET_REQUEST: "groups/GET_REQUEST",
  GET_SUCCESS: "groups/GET_SUCCESS",
  GET_FAILURE: "groups/GET_FAILURE",

  GET_LIST_REQUEST: "groups/GET_LIST_REQUEST",
  GET_LIST_SUCCESS: "groups/GET_LIST_SUCCESS",
  GET_LIST_FAILURE: "groups/GET_LIST_FAILURE",

  CREATE_REQUEST: "groups/CREATE_REQUEST",
  CREATE_SUCCESS: "groups/CREATE_SUCCESS",
  CREATE_FAILURE: "groups/CREATE_FAILURE",

  UPDATE_REQUEST: "groups/UPDATE_REQUEST",
  UPDATE_SUCCESS: "groups/UPDATE_SUCCESS",
  UPDATE_FAILURE: "groups/UPDATE_FAILURE",

  GET_ROLES_REQUEST: "groups/GET_ROLES_REQUEST",
  GET_ROLES_SUCCESS: "groups/GET_ROLES_SUCCESS",
  GET_ROLES_FAILURE: "groups/GET_ROLES_FAILURE",
};

const initialState = {
  data: [],
  loading: true,
  page: 1,
  totals: 1,

  detail: {
    data: {},
    loading: true,
  },

  create: {
    loading: false,
  },

  update: {
    loading: false,
  },

  roles: {
    data: [],
    loading: false,
  },
};

export default function groups(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REQUEST:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
        },
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload.group.data,
        },
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
        },
      };
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.groups.data,
        page: action.payload.groups.meta.current_page,
        totals: action.payload.groups.meta.total_pages,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.CREATE_REQUEST:
      return {
        ...state,
        create: {
          ...state.create,
          loading: true,
        },
      };
    case Types.CREATE_SUCCESS:
    case Types.CREATE_FAILURE:
      return {
        ...state,
        create: {
          ...state.create,
          loading: false,
        },
      };
    case Types.UPDATE_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          loading: true,
        },
      };
    case Types.UPDATE_SUCCESS:
    case Types.UPDATE_FAILURE:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
        },
      };
    case Types.GET_ROLES_REQUEST:
      return {
        ...state,
        roles: {
          ...state.roles,
          loading: false,
        },
      };
    case Types.GET_ROLES_SUCCESS:
      return {
        ...state,
        roles: {
          ...state.roles,
          loading: false,
          data: action.payload.roles.data,
        },
      };
    case Types.GET_ROLES_FAILURE:
      return {
        ...state,
        roles: {
          ...state.roles,
          loading: false,
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  getGroupRequest: (id) => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),

  getGroupSuccess: (group) => ({
    type: Types.GET_SUCCESS,
    payload: { group },
  }),

  getGroupFailure: () => ({
    type: Types.GET_FAILURE,
  }),

  getGroupsRequest: (page = 1) => ({
    type: Types.GET_LIST_REQUEST,
    payload: { page },
  }),

  getGroupsSuccess: (groups) => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { groups },
  }),

  getGroupsFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),

  createGroupRequest: (data) => ({
    type: Types.CREATE_REQUEST,
    payload: { data },
  }),

  createGroupSuccess: () => ({
    type: Types.CREATE_SUCCESS,
  }),

  createGroupFailure: () => ({
    type: Types.CREATE_FAILURE,
  }),

  updateGroupRequest: (id, data) => ({
    type: Types.UPDATE_REQUEST,
    payload: { id, data },
  }),

  updateGroupSuccess: () => ({
    type: Types.UPDATE_SUCCESS,
  }),

  updateGroupFailure: () => ({
    type: Types.UPDATE_FAILURE,
  }),

  getGroupsRolesRequest: (query = "") => ({
    type: Types.GET_ROLES_REQUEST,
    payload: { query },
  }),

  getGroupsRolesSuccess: (roles) => ({
    type: Types.GET_ROLES_SUCCESS,
    payload: { roles },
  }),

  getGroupsRolesFailure: () => ({
    type: Types.GET_ROLES_FAILURE,
  }),
};

export const Selectors = {
  roles: createSelector(
    (state) => state,
    (roles) =>
      roles.map((role) => ({ value: role.id, label: role.attributes.title }))
  ),
};
